module.exports = __webpack_public_path__ + "img/menorRedIcon.340a6043.svg";